import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CustomStorage } from '../providers/Custom-storage.service';
import { LanguageService } from '../providers/lang.service';
import { environment } from '../../environments/environment';
import { RestApiServices } from '../providers/rest.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Constant } from '../Constant'
@Component({
  selector: 'app-invoicedescription',
  templateUrl: './invoicedescription.component.html',
  styleUrls: ['./invoicedescription.component.css']
})
export class InvoicedescriptionComponent implements OnInit {
  //invoiceDetails:Object;
  private imageUrl: string = environment.imageUrl;
  invoiceDetails: any = {};
  invoice: string = "";invoiced: string = "";declined_payment: string = "";declined_description: string = "";
  return_check: string = "";shipped_on: string = "";sub_toal: string = "";due_on :string ="";
  item_text: string = "";quantity: string = "";shipping_handling: string = "";total: string = "";
  total_collected: string = ""; total_outstanding: string = ""; invoice_details: string = ""; city_tax: string=""
  state_tax: string = "";lbl_uom : string = "";lbl_qty : string = ""; lbl_pack: string = "Pack Size";
  IsHidden = true;
  invoices: any;
  invoiceNumber:any;
  orderNumber:any;
  isGetInvoiceDetail:any;
  invoiceLength = false;
  constructor(public router:Router, private route: ActivatedRoute, private restApi: RestApiServices,private location: Location,private langService: LanguageService, private localStorage: CustomStorage) { 
    var invoiceNumber = route.snapshot.params['invoiceNumber'];
    this.isGetInvoiceDetail = route.snapshot.params['isGetInvoiceDetail'];
    
    if(invoiceNumber) {
      this.invoiceNumber = invoiceNumber;
    }
  }

  ngOnInit() {
    this.setLabels();
    var invoiceData;
    if(this.invoiceNumber && this.isGetInvoiceDetail) {
      // alert(this.invoiceNumber)
      this.IsHidden = false;
      this.restApi.getInvoiceDetail(this.invoiceNumber).subscribe(items => {

        if (items.response.status_code === 200 && items.response.error_message === '') {
          
          if (items.response.invoices[0] && items.response.invoices != "") {
            this.invoices = items.response.invoices[0];

            this.invoiceDetails = [];

            if (this.invoices) {

              this.invoiceDetails = this.invoices;
              this.invoiceLength = true;

            } else {

              window.alert('No results found');
            }
            this.IsHidden = true;

          }
        } 
        this.IsHidden = true;
      });
    } else if(this.invoiceNumber) {

      this.IsHidden = false;
      this.restApi.getInvoiceDetail(this.invoiceNumber).subscribe(items => {

        if (items.response.status_code === 200 && items.response.error_message === '') {
          
          if (items.response.invoices[0] && items.response.invoices != "") {
            this.invoices = items.response.invoices[0];

            this.invoiceDetails = [];

            if (this.invoices) {

              this.invoiceDetails = this.invoices;
              this.invoiceLength = true;

            } else {

              window.alert('No results found');
            }
            this.IsHidden = true;

          }
        } 
        this.IsHidden = true;
      });
      // this.localStorage.getItem(Constant.KEY_INVOICEDATA).subscribe(data => {
      //   if (data != null && data != undefined) {

      //     this.invoices = data.response.invoices;

      //     invoiceData = this.invoices.filter(invoices_d => invoices_d.invoice_number === this.invoiceNumber);
          
      //     invoiceData = this.invoices.filter(invoices_d => invoices_d.order_number === this.invoiceNumber);

      //     this.invoiceDetails = [];

      //     if(invoiceData[0]) {

      //       this.invoiceDetails = invoiceData[0];
      //       this.invoiceLength = true;

      //     } else {

      //       window.alert('No results found');
      //     }

      //     this.IsHidden = true;
      
      //   } else {
      //     this.restApi.getinvoicehistory().subscribe(items => {

      //       if (items.response.status_code === 200 && items.response.error_message === '') {
      //         if (items.response.invoices != "") {
      //           this.invoices = items.response.invoices;
      //           if (this.invoices) {
      //             invoiceData = this.invoices.filter(invoices_d => invoices_d.invoice_number === this.invoiceNumber);
      //             invoiceData = this.invoices.filter(invoices_d => invoices_d.order_number === this.invoiceNumber);
      //           }

      //           this.invoiceDetails = [];

      //           if (invoiceData[0]) {

      //             this.invoiceDetails = invoiceData[0];
      //             this.invoiceLength = true;

      //           }
      //           this.IsHidden = true;

      //         }
      //       } 
      //       this.IsHidden = true;
      //     });
      //   }
      // });
    } else {
      this.langService.getJson().subscribe(data => {
        this.localStorage.getItem('invoiceSelected').subscribe(data => {
          if (data)
            this.invoiceDetails = data;
            this.invoiceLength = true;
        });
      });
    }
   
  }

  getTotalCartAmount() {
    if (this.invoiceDetails) {
      let totalcartamount = this.invoiceDetails.invoice_items;
      if(totalcartamount != null){
      const bArray = totalcartamount.map(({ unit_price, quantity }) => unit_price * quantity);
      const res = bArray.reduce(function (a, b) { return a + b; }, 0);
      const result = Math.round(res * 100) / 100;
      return result;
      }
    }
  }
  setLabels() {

    this.langService.getLangLabelValue("LblInvoice").then(result => {
      this.invoice = result;
    });
    this.langService.getLangLabelValue("LblInvoiced").then(result => {
      this.invoiced = result;
    });
    this.langService.getLangLabelValue("LblDeclinedPayment").then(result => {
      this.declined_payment = result;
    });
    this.langService.getLangLabelValue("LblDeclinedPaymentMessage").then(result => {
      this.declined_description = result;
    });
    this.langService.getLangLabelValue("LblReturnedCheck").then(result => {
      this.return_check = result;
    });
    this.langService.getLangLabelValue("LblShippedOnInv").then(result => {
      this.shipped_on = result;
    });
    this.langService.getLangLabelValue("LblSubTotal").then(res => {
      this.sub_toal = res
    });
    this.langService.getLangLabelValue("LblDueOn").then(res => {
      this.due_on = res
    });
    this.langService.getLangLabelValue("LblItem").then(res => {
      this.item_text = res
    });
    this.langService.getLangLabelValue("LblQuantity").then(res => {
      this.quantity = res
    });
    this.langService.getLangLabelValue("LblShipping_Handling").then(res => {
      this.shipping_handling = res
    });
    this.langService.getLangLabelValue("LblTotal").then(res => {
      this.total = res
    });
    this.langService.getLangLabelValue("LblTotalCollected").then(res => {
      this.total_collected = res
    });
    this.langService.getLangLabelValue("LblTotalOutstanding").then(res => {
      this.total_outstanding = res
    });
    this.langService.getLangLabelValue("LblInvoiceDetails").then(res => {
      this.invoice_details = res
    });
    this.langService.getLangLabelValue("LblCityTax").then(res => {
      this.city_tax = res
    });
    this.langService.getLangLabelValue("LblStateTax").then(res => {
      this.state_tax = res
    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;  
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;  
    });
  }
  close() {
    this.location.back();
    // this.router.navigate(['/dashboard/invoice']);
  }
}



// WEBPACK FOOTER //
// ./src/app/invoicedescription/invoicedescription.component.ts